import { Injectable } from '@angular/core';
import { LockObjectHistory } from '@osos/shared/api';
import {
  LockHistoryStateEnum,
  LockObjectHistoryPresenterModel,
} from '@osos/shared/types';
import { ParserBase } from '../../bases';

@Injectable()
export class LockObjectParserV1Service extends ParserBase<
  LockObjectHistory,
  LockObjectHistoryPresenterModel
> {
  constructor() {
    super(LockObjectHistory, LockObjectHistoryPresenterModel, 1);
  }

  getPresenterModel(
    model: Partial<LockObjectHistory>,
  ): LockObjectHistoryPresenterModel {
    return {
      id: model.id,
      action: model.action,
      lockedBy:
        model.action === LockHistoryStateEnum.Lock ||
        model.action === LockHistoryStateEnum.Extend
          ? model.lockedBy
          : undefined,
      unlockedBy:
        model.action === LockHistoryStateEnum.Unlock
          ? model.lockedBy
          : undefined,
      lockedObject: model.lockedObject,
      lockEndDate: model.lockEndDate,
      lockStartDate: model.lockStartDate,
      actionInfo: model.actionInfo,
    };
  }
  getDataModel(presenter: LockObjectHistoryPresenterModel): LockObjectHistory {
    return {
      id: presenter.id,
      action: presenter.action,
      lockedBy: presenter.lockedBy,
      lockedObject: presenter.lockedObject,
      lockEndDate: presenter.lockEndDate,
      lockStartDate: presenter.lockStartDate,
      actionInfo: presenter.actionInfo,
    };
  }
}
